// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-menu[data-v-18b67dab]{display:inline-block;color:#242b59;font-size:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
